import React, { useEffect, useState } from 'react'
import TextField from '../../whitaijiFrontendLibrary/components/TextField'
import { Country, State, City }  from 'country-state-city';
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import FieldDropdown from '../../whitaijiFrontendLibrary/components/FieldDropdown';
import Loading from '../../whitaijiFrontendLibrary/components/Loading';
import T from '../../components/Translation';
import { CheckButton } from './materials/CheckButton';
import { CiCircleCheck } from "react-icons/ci";
import { HiCheckCircle } from "react-icons/hi2";
import { CheckBox } from './materials/CheckBox';

const PersonalData = ({data, hideConsent, showValidation, onValidationChange}) => {
   //#surveyResponse
  const {doc, setDoc} = data
  const [loading, setLoading] = useState(true)
  const [firstName, setFirstName] = useState(doc?.firstName)
  const [professionalTitle, setProfessionalTitle] = useState(doc?.professionalTitle)
  const [lastName, setLastName] = useState(doc?.lastName)
  const [email, setEmail] = useState(doc?.email)
  const [country, setCountry] = useState(doc?.country?.countryCode ? doc?.country : undefined)
  const [city, setCity] = useState(doc?.city?.countryCode ? doc?.city : undefined)
  const [cityList, setCityList] = useState()
  const [phoneNumber, setPhoneNumber] = useState(doc?.phoneNumber)
  const [errors, setErrors] = useState({})
  const [touched, setTouched] = useState({})

  
  const validateField = (name, value) => {
    //#surveyErrorValidation
    //#surveyResponse
    switch (name) {
      case 'firstName':
        return !value ? <T obj={{en:'First name is required', it:'Il nome è obbligatorio'}}/>  : '';
      case 'lastName':
        return !value ? <T obj={{en:'Last name is required', it:'Il cognome è obbligatorio'}}/> : '';
      case 'email':
        return !value ? <T obj={{en:'Email is required', it:'L\'email è obbligatoria'}}/> : 
               !/\S+@\S+\.\S+/.test(value) ? <T obj={{en:'Email is invalid', it:'Email non valida'}}/> : '';
      case 'country':
        return !value?.label ? <T obj={{en:'Country is required', it:'Il paese è obbligatorio'}}/> : '';
      case 'city':
        // Only require city if country is selected and cities are available
        if (!country || !cityList?.length) {
          return '';
        }
        return !value?.label ? <T obj={{en:'City is required', it:'La città è obbligatoria'}}/> : '';
      case 'acceptPrivacy':
        return !value ? <T obj={{en:'You must accept the privacy policy', it:'Devi accettare l\'informativa sulla privacy'}}/> : '';
      default:
        return '';
    }
  }

  const validateAllFields = (overrides = {}) => {
    //#surveyErrorValidation
    //#surveyResponse
    const newErrors = {
      firstName: validateField('firstName', overrides.firstName ?? firstName),
      lastName: validateField('lastName', overrides.lastName ?? lastName),
      email: validateField('email', overrides.email ?? email),
      country: validateField('country', overrides.country ?? country),
      city: validateField('city', overrides.city ?? city),
      acceptPrivacy: validateField('acceptPrivacy', overrides.acceptPrivacy ?? doc.acceptPrivacy)
    };

    // Filter out empty error messages
    const actualErrors = Object.entries(newErrors)
      ?.filter(([_, value]) => value !== '')
      ?.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    return { newErrors, actualErrors };
  }

  const handleValidation = (actualErrors, touchedFields = []) => {
    const hasErrors = Object.keys(actualErrors).length > 0;
    
    if (hasErrors) {
      setErrors(actualErrors);
      // Only set touched for specified fields with errors
      const newTouched = {};
      touchedFields.forEach(field => {
        if (actualErrors[field]) {
          newTouched[field] = true;
        }
      });
      setTouched(newTouched);
    } else {
      setErrors({});
      setTouched({});
    }

    if (onValidationChange) {
      onValidationChange(hasErrors);
    }

    return hasErrors;
  }

  const handleBlur = (field) => {
    // Skip validation if not enabled
    if (!showValidation) {
      if (onValidationChange) {
        onValidationChange(false);
      }
      return;
    }
    
    const { actualErrors } = validateAllFields();
    handleValidation(actualErrors, [field]);
  }

  const validateForm = () => {
    // Skip validation if not enabled
    if (!showValidation) {
      if (onValidationChange) {
        onValidationChange(false);
      }
      return true;
    }
    
    const { actualErrors } = validateAllFields();
    const hasErrors = handleValidation(actualErrors, Object.keys(actualErrors));
    return !hasErrors;
  }

  const handleSubmit = (e) => {
    e?.preventDefault()
    return validateForm()
  }

  useEffect(() => {
    //#surveyErrorValidation
    //#surveyResponse
    // Skip validation if not enabled
    if (!showValidation) {
      setErrors({});
      setTouched({});
      if (onValidationChange) {
        onValidationChange(false);
      }
      return;
    }

    const { actualErrors } = validateAllFields();
    handleValidation(actualErrors, Object.keys(actualErrors));
    //#surveyErrorValidation
    //#surveyResponse
  }, [showValidation, firstName, lastName, email, country, city, doc.acceptPrivacy]);
      
  const countries = Country.getAllCountries()
  const cities = (countryCode) => City.getCitiesOfCountry(countryCode)?.map((city)=>{
    if(city?.countryCode == "US"){return({...city, label: `${city.name}, ${city.stateCode}`, value:`${city.name}, ${city.stateCode}` })}
    return ({...city, label: city.name, value:city.name })
})
  useEffect(() => {
    // Update states when doc changes
    setFirstName(doc?.firstName);
    setLastName(doc?.lastName);
    setEmail(doc?.email);
    setCountry(doc?.country?.countryCode ? doc?.country : undefined);
    setCity(doc?.city?.countryCode ? doc?.city : undefined);
    setPhoneNumber(doc?.phoneNumber);
    setProfessionalTitle(doc?.professionalTitle);
  }, [doc]);

  useEffect(() => {
      if(countries) {
        setLoading(false)
      }
      if(country) {
        setCityList(cities(country?.isoCode))
      }
  }, [countries, country])
  const addCountry = (data) => {
    setLoading(true)
    setCountry(data)
    setDoc({...doc, country: {
      label: data?.name,
      latitude: data?.latitude,
      longitude: data?.longitude,
      countryCode: data?.isoCode,
      isoCode: data?.isoCode,
      timeZone: data?.timezones?.length>0 ? data?.timezones[0]?.zoneName : null
  }})
    setLoading(false)   
}
const addCity = (data) => {
    setCity(data)
    setDoc({...doc, city: {
      label: data?.name,
      latitude: data?.latitude,
      longitude: data?.longitude,
      countryCode: data?.countryCode,

  }})
}

  if (loading) {
    return (
      <Loading/>
    )
  }

  const handleFieldChange = (field, value, additionalUpdates = {}) => {
    // Skip validation if not enabled
    if (!showValidation) {
      if (onValidationChange) {
        onValidationChange(false);
      }
      return;
    }

    const { actualErrors } = validateAllFields({ [field]: value, ...additionalUpdates });
    handleValidation(actualErrors, Object.keys(actualErrors));
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          label={<T obj={{en:'First Name *', it:'Nome *'}}/>}
          type={"text"}
          value={firstName}
          isError={touched.firstName && !!errors.firstName}
          errorMessage={errors.firstName}
          onChange={(e) => {
            const value = e.target.value;
            setFirstName(value);
            setDoc({...doc, firstName: value});
            handleFieldChange('firstName', value);
          }}
          onBlur={() => handleBlur('firstName')}
        />
        <TextField
          label={<T obj={{en:'Last Name *', it:'Cognome *'}}/>}
          type={"text"}
          value={lastName}
          isError={touched.lastName && !!errors.lastName}
          errorMessage={errors.lastName}
          onChange={(e) => {
            const value = e.target.value;
            setLastName(value);
            setDoc({...doc, lastName: value});
            handleFieldChange('lastName', value);
          }}
          onBlur={() => handleBlur('lastName')}
        />
        <VisDiv>
          <TextField
            label={<T obj={{en:'Professional Title', it:'Titolo professionale'}}/>}
            type={"text"}
            value={professionalTitle}
            onChange={(e) => {
              const value = e.target.value;
              setProfessionalTitle(value);
              setDoc({...doc, professionalTitle: value});
              //handleFieldChange('professionalTitle', value);
            }}
            onBlur={() => handleBlur('professionalTitle')}
          />
        
        </VisDiv>
        <TextField
          label={"Email *"}
          type={"email"}
          value={email}
          isError={touched.email && !!errors.email}
          errorMessage={errors.email}
          onChange={(e) => {
            const value = e.target.value;
            setEmail(value);
            setDoc({...doc, email: value});
            handleFieldChange('email', value);
          }}
          onBlur={() => handleBlur('email')}
        />
        <TextField
          label={<T obj={{en:'Phone Number', it:'Numero di telefono'}}/>}
          type={"text"}
          value={phoneNumber}
          onChange={(e) => {
            setPhoneNumber(e.target.value);
            setDoc({...doc, phoneNumber: e.target.value});
          }}
        />
      <div>
        <p>
          <T obj={{
            en: "We gather this data just to see if we have enough interest to organise events and concerts in your country and city. We don't ask for your personal address",
            it: "Raccogliamo questa informazione per vedere se abbiamo abbastanza interesse per organizzare concerti ed eventi nella tua città. Non chiediamo il tuo indirizzo personale"
          }}/>
        </p>
      </div>
      <VisDiv style={{marginTop:"10px"}} rules={[true]}>
        <h4>{<T obj={{en:'Country *', it:'Paese *'}}/>}:</h4>
      </VisDiv>
        <FieldDropdown
          isSearchable="isSearchable"
          onChange={(value)=>{
              setCity(null)
              setCityList(null)
              addCountry(value)
              handleFieldChange('country', value, { city: null });
          }}
          onBlur={() => handleBlur('country')}
          options={countries?.map((country)=>({...country, label: country.name, value:country.name }))} 
          placeHolder={<T obj={{en:'Select Country *', it:'Seleziona Paese *'}}/>}
          initialValue={!country ? undefined : {...country, value: country?.name}}
          isError={touched.country && !!errors.country}
          errorMessage={errors.country}
        />
      <VisDiv rules={[country, cityList?.length>0]}>
          <VisDiv style={{marginTop:"30px"}} rules={[true]}>
            <h4><T obj={{en:'City *', it:'Città *'}}/>:</h4>
          </VisDiv>
          <FieldDropdown
              isSearchable="isSearchable"
              initialValue={!city ? undefined : {...city, value: city?.label}}
              placeHolder={<T obj={{en:'Select City *', it:'Seleziona Citta *'}}/>}
              onChange={(value) => {
                addCity(value);
                handleFieldChange('city', value);
              }}
              onBlur={() => handleBlur('city')}
              options={cityList}
              isError={touched.city && !!errors.city}
              errorMessage={errors.city}
          />
      </VisDiv>
        <VisDiv rules={[!hideConsent]} style={{marginTop:"30px"}}>
          <CheckBox 
            data={data} 
            objKey={"acceptPrivacy"} 
            label={<T obj={{en:'I consent to the processing of my personal data as stated in the Privacy Policy *', it:'Accetto il trattamento dei miei dati personali secondo l\'informativa sulla privacy *'}}/>}
            isError={touched.acceptPrivacy && !!errors.acceptPrivacy}
            errorMessage={errors.acceptPrivacy}
            onBlur={() => handleBlur('acceptPrivacy')}
            onChange={(checked) => {
              setDoc({...doc, acceptPrivacy: checked});
              handleFieldChange('acceptPrivacy', checked);
            }}
          />
        </VisDiv>
        <div style={{marginTop:"10px"}}>
          <CheckBox 
            data={data} 
            objKey={"acceptMarketing"} 
            label={<T obj={{
              en:'I want to know when there are concerts and events in my area, live streaming events, news and updates about reMind (we will not spam you or share your data)', 
              it:'Voglio sapere quando ci sono concerti ed eventi nella mia zona, live streaming, notizie e aggiornamenti su reMind (non ti invieremo spam né condivideremo i tuoi dati).'
            }}/>}
            //isError={touched.acceptMarketing && !!errors.acceptMarketing}
            //errorMessage={errors.acceptPrivacy}
            onBlur={() => handleBlur('acceptMarketing')}
            onChange={(checked) => {
              setDoc({...doc, acceptMarketing: checked});
              handleFieldChange('acceptMarketing', checked);
            }}
          />
        </div>
      </form>
    </div>
  )
}

export default PersonalData
